module.exports = __webpack_public_path__ + "img/icon-chengshi@2x.8252d2fd.png";